
export function parseHolidayCSV(csvText) {
    const lines = csvText.split('\n');
    const headers = lines[0].split(',').map(h => h.trim());

    const holidays = [];

    // Simple CSV parser that handles quotes
    function parseLine(line) {
        const result = [];
        let current = '';
        let inQuotes = false;
        for (let i = 0; i < line.length; i++) {
            const char = line[i];
            if (char === '"') {
                inQuotes = !inQuotes;
            } else if (char === ',' && !inQuotes) {
                result.push(current.trim());
                current = '';
            } else {
                current += char;
            }
        }
        result.push(current.trim());
        return result;
    }

    for (let i = 1; i < lines.length; i++) {
        const line = lines[i].trim();
        if (!line) continue;

        const values = parseLine(line);
        const entry = {};

        headers.forEach((header, index) => {
            entry[header] = values[index] !== undefined ? values[index] : '';
        });

        holidays.push(entry);
    }

    return holidays;
}

export async function fetchHolidays(filename) {
    try {
        const response = await fetch(`/${filename}`);
        if (!response.ok) {
            throw new Error(`Failed to fetch ${filename}`);
        }
        const csvText = await response.text();
        return parseHolidayCSV(csvText);
    } catch (error) {
        console.error(`Error fetching holidays from ${filename}:`, error);
        return [];
    }
}

export function getUpcomingHolidays(holidays, limit = 5) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return holidays
        .map(h => ({
            ...h,
            dateObj: new Date(h.Date)
        }))
        .filter(h => h.dateObj >= today)
        .sort((a, b) => a.dateObj - b.dateObj)
        .slice(0, limit);
}
